import { render, staticRenderFns } from "./CustomerOrgNeWindow.vue?vue&type=template&id=25b66858&"
import script from "./CustomerOrgNeWindow.vue?vue&type=script&lang=js&"
export * from "./CustomerOrgNeWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports